import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getTopClients} from "../../store/reducers/ClientsSlice";
import RangeSearch from "./components/RangeSearch";
import {getProfits} from "../../store/reducers/ResultsSlice";

interface ProfitResultsScreenProps {
}

export const ProfitResultsScreen: React.FC<ProfitResultsScreenProps> = () => {

    const dispatch = useAppDispatch();

    const resultsState = useAppSelector(state => state.results);

    useEffect(() => {
        dispatch(getProfits());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Vedude ülevaade kasumi järgi</h1>
            <RangeSearch url={'results/status'} userVisible={true} />
            <table className="data">
                <thead>
                <tr>
                    <th className="left">Kogus</th>
                    <th className="left">
                        Vahemiku kasum
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▲
                        </a>
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▼
                        </a>
                    </th>
                    <th className="left">
                        Osakaal kogukasumist
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▲
                        </a>
                        <a style={{ textDecoration: 'none' }} href="#">
                            ▼
                        </a>
                    </th>
                </tr>
                </thead>
                <tbody>
                {resultsState.profits.map(profit => (
                    <tr>
                        <td>{profit.name}</td>
                        <td>{profit.amount}</td>
                        <td>{profit.percentage}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </LoggedInView>
    )

}